const GA = {
    event(category, action, label, value) {
        if (!category || !action) {
            console.error('Both category and action are required!', category, action);
        }

        if (!window.ga) {
            console.warn('Cannot log GA event:', category, action, label || null, value || null);
            return;
        }

        window.ga('send', 'event', category, action, label, value);
    }
};

module.exports = GA;

global.GA = GA;